import { ResponsivePie } from "@nivo/pie";

const SLICE_COLORS = [
  "#d3963a",
  "#c4853e",
  "#b07a44",
  "#8e6e50",
  "#6e6060",
  "#9b8b7e",
  "#c0a882",
  "#e8c97a",
];

function PieChart({ data }) {
  const total = data.reduce((sum, row) => {
    return sum + (row.arrUp || 0) + (row.noshow || 0) + (row.cancel || 0);
  }, 0);

  if (total === 0) return null;

  const pieData = data
    .map((row) => ({
      id: `${row.numGuests}`,
      label: `${row.numGuests} guests`,
      value: (row.arrUp || 0) + (row.noshow || 0) + (row.cancel || 0),
    }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 10)
    .map((row, i) => ({ ...row, color: SLICE_COLORS[i % SLICE_COLORS.length] }));

  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", height: "100%", width: "100%", gap: "16px" }}>
      <div style={{ flex: "0 0 auto", height: "100%", aspectRatio: "1 / 1" }}>
        <ResponsivePie
          data={pieData}
          colors={{ datum: "data.color" }}
          margin={{ top: 42, right: 12, bottom: 12, left: 2 }}
          innerRadius={0.55}
          padAngle={2}
          cornerRadius={3}
          activeOuterRadiusOffset={6}
          borderWidth={0}
          enableArcLabels={false}
          enableArcLinkLabels={false}
          isInteractive={true}
          tooltip={({ datum }) => (
            <div
              style={{
                background: "#111115",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "7px",
                padding: "8px 12px",
                fontSize: "13px",
                color: "#f0ede8",
                fontFamily: "Inter, sans-serif",
                display: "flex", 
                flexDirection: "column",
                gap: "2px",
              }}
            >
              <span style={{ fontWeight: 700, color: datum.color }}>{datum.label}</span>
              <span>{datum.value} reservation{datum.value !== 1 ? "s" : ""}</span>
              <span style={{ opacity: 0.6 }}>{((datum.value / total) * 100).toFixed(1)}%</span>
            </div>
          )}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "7px", flex: 1, overflowY: "auto" }}>
        {pieData.map((slice) => (
          <div key={slice.id} style={{ display: "flex", alignItems: "center", gap: "9px", fontSize: "13px" }}>
            <div style={{ width: "9px", height: "9px", borderRadius: "50%", background: slice.color, flexShrink: 0 }} />
            <span style={{ color: "rgba(240,237,232,0.65)", minWidth: "55px" }}>{slice.label}</span>
            <span style={{ color: "#f0ede8", fontWeight: 600, marginLeft: "auto" }}>
              {((slice.value / total) * 100).toFixed(1)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PieChart;
